{
  "version": 1,
  "asset_id": "df8ce1dc-17ba-4bac-b446-e3598ac59e51",
  "project_id": "e3708065-dee2-4f65-a2de-1d1b02caf785",
  "url": "/__l5e/assets-v1/df8ce1dc-17ba-4bac-b446-e3598ac59e51/the-rebirth-sutra-cover.png",
  "r2_key": "a/v1/e3708065-dee2-4f65-a2de-1d1b02caf785/df8ce1dc-17ba-4bac-b446-e3598ac59e51/the-rebirth-sutra-cover.png",
  "original_filename": "the-rebirth-sutra-cover.png",
  "size": 2926652,
  "content_type": "image/png",
  "created_at": "2026-07-15T00:40:26Z"
}
